/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
// GSAP animations for numbered-wysiwyg block
const gsapNumberedWysiwygAnimations = () => {
	const blocks = document.querySelectorAll(".numbered-wysiwyg.has-image");

	if (!blocks.length) return;

	// Use GSAP's native matchMedia for responsive animations
	ScrollTrigger.matchMedia({
		// Only run animations on screens 1024px and above
		"(min-width: 1025px)": function() {
			blocks.forEach((block) => {
				const contentWrapper = block.querySelector(".numbered-wysiwyg__content-wrapper");
				const imageSection = block.querySelector(".numbered-wysiwyg__image");
				
				if (!contentWrapper || !imageSection) return;

				// Get the height difference between image and content
				const imageHeight = imageSection.offsetHeight;
				const contentHeight = contentWrapper.offsetHeight;
				const maxMove = Math.max(0, imageHeight - contentHeight);

				if (maxMove > 0) {
					// Create the scroll-triggered animation
					gsap.fromTo(contentWrapper, 
						{
							y: 0
						},
						{
							y: maxMove,
							ease: "none",
							scrollTrigger: {
								trigger: block,
								start: "top center",
								end: "top top",
								scrub: true,
								invalidateOnRefresh: true,
							}
						}
					);
				}
			});
		}
	});
};

// Initialize when DOM is ready
if (document.readyState !== "loading") {
	gsapNumberedWysiwygAnimations();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		gsapNumberedWysiwygAnimations();
	});
}
